import { ConcurrentExperience } from '@atlaskit/ufo/concurrent-experience';
import { ExperiencePerformanceTypes, ExperienceTypes } from '@atlaskit/ufo/experience-types';

export const CSM_AI_WIDGET_STORE_UFO_EXPERIENCES: {
	readonly SEND_MESSAGE: ConcurrentExperience;
	readonly INITIALIZE_TWILIO_LIVE_CHAT: ConcurrentExperience;
	readonly END_TWILIO_LIVE_CHAT: ConcurrentExperience;
	readonly HYDRATE_TWILIO_LIVE_CHAT: ConcurrentExperience;
	readonly SEND_TWILIO_LIVE_CHAT_MESSAGE: ConcurrentExperience;
} = {
	SEND_MESSAGE: new ConcurrentExperience('csm-ai-widget-send-message', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
	/**
	 * Tracks the help-seeker starting a Twilio live chat conversation, both
	 * via the CSM direct-chat hand-off (`initializeDirectLiveChatImpl`) and
	 * via the JSM AI hand-off (`initializeTwilioConversationImpl`).
	 */
	INITIALIZE_TWILIO_LIVE_CHAT: new ConcurrentExperience('csm-twilio-live-chat-initialize', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
	/**
	 * Tracks the help-seeker (or the underlying provider) ending an active
	 * Twilio live chat conversation via the close API call in
	 * `live-chat-close-provider.tsx`.
	 */
	END_TWILIO_LIVE_CHAT: new ConcurrentExperience('csm-twilio-live-chat-end', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
	/**
	 * Tracks the "continue active chat" flow on widget mount/refresh, where an
	 * existing Twilio conversation is rehydrated via `getTwilioConversation`.
	 * Fires from `restoreConversationsOnClient` (token refresh / new client) and
	 * `hydrateTwilioConversationImpl` (initial chat-history rehydration).
	 */
	HYDRATE_TWILIO_LIVE_CHAT: new ConcurrentExperience('csm-twilio-live-chat-hydrate', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
	/**
	 * Tracks the help-seeker sending a message on an established Twilio live
	 * chat conversation (i.e. the Twilio `Conversation.sendMessage` call).
	 * This is distinct from the AI-store `SEND_MESSAGE` experience which
	 * tracks AI message turns (Barista request lifecycle).
	 */
	SEND_TWILIO_LIVE_CHAT_MESSAGE: new ConcurrentExperience('csm-twilio-live-chat-send-message', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
} as const;
